export class Balance {
    constructor(public balance: number) {}
}
